module.exports = __webpack_public_path__ + "img/DNADamage-LICA_PLC.4ed06d8b.png";